import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the BusinessProductSubcategoryListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
@Component({
  selector: 'page-business-product-subcategory-list',
  templateUrl: 'business-product-subcategory-list.html',
})
export class BusinessProductSubcategoryListPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad BusinessProductSubcategoryListPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/business-product-subcategory-list/business-product-subcategory-list.ts